var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{attrs:{"align-h":"center","cols-lg":"2","cols-sm":"1"}},[_c('b-card',[_c('div',{staticClass:"text-center"},[_c('b-button',{staticClass:"w-100",attrs:{"variant":"primary","size":"lg"},on:{"click":_vm.loginWithAuth0}},[_vm._v(" Login ")])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }